export class User {
  username: string;
  name: string;
  partnerName: string;
  partnerId: number;
  authorities: string[];

  constructor() {
    this.username = '';
    this.name = '';
    this.partnerName = '';
    this.partnerId = 1;
    this.authorities = [];
  }
}



// WEBPACK FOOTER //
// ./src/models/user.ts